import React from "react";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
    root: {
        marginTop: 18,
        padding: '2px 4px',
        display: "flex",
        width: "100%",
        maxWidth: 800
    },
    content: {
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexFlow: "column nowrap"
    },
    loading: {
        marginBottom: 20
    }
});

export default function PropertyDetails({message}) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <div className={classes.loading}>
                    <Typography variant="h6">{message}</Typography>
                </div>
                <CircularProgress color="primary" size={100} />
            </div>
        </div>
    )
}